import config from "environment";
import { getRequest, postRequest } from "./client";
import { 
  CreateFormResponseCompletePayload,
  DeleteFormResponsesPayload,
  FormResponseExtended,
  Response,
  ShadowCopyFormResponsesPayload
} from "effno-core";

const { baseApi } = config;

export async function apiGetResponse(id: string) {
  const fetchURL = `${baseApi}/responses/${id}`;
  return await getRequest(fetchURL, "API/apiGetResponse");
}

export async function apiGetResponsesForFormResponse(formResponseId: string) : Promise<Response[] | null> {
  const fetchURL = `${baseApi}/responses/form-response/${formResponseId}`;
  return await getRequest(fetchURL, "API/apiGetResponseForFormResponse");
}

// export async function apiCreateResponseForFormResponse(payload: CreateResponseForFormResponsePayload) : Promise<Response | null> {
//   const fetchURL = `${baseApi}/responses/create-response`;
//   return await postRequest(fetchURL, payload, "API/apiCreateResponseForFormResponse");
// }

export async function apiGetFormResponsesForForm(formId: string) : Promise<FormResponseExtended[] | null> {
  const fetchURL = `${baseApi}/responses/form-responses/form/${formId}`;
  return await getRequest(fetchURL, "API/apiGetFormResponsesForForm");
}

export async function apiGetFormResponseCountForForm(formId: string) : Promise<number | null> {
  const fetchURL = `${baseApi}/responses/response-count/form/${formId}`;
  return await getRequest(fetchURL, "API/apiGetFormResponseCountForForm");
}

// note this assumes the questions/responses are in order
// and that there are empty responses for any questions that get
// skipped over in workflow. In other words this will be the complete
// set of responses for a form

export async function apiCreateFormResponseComplete(payload: CreateFormResponseCompletePayload) : 
  Promise<FormResponseExtended | null> {
  const fetchURL = `${baseApi}/responses/create-form-response`;
  return await postRequest(fetchURL, payload, "API/apiCreateFormResponse");
}

export async function apiDeleteFormResponses(payload: DeleteFormResponsesPayload) : Promise<number | null> {
  const fetchURL = `${baseApi}/responses/delete-form-responses`;
  return await postRequest(fetchURL, payload, "API/apiDeleteFormResponses");
}

export async function apiDeleteResponse(responseId: string) : Promise<number | null> {
  const fetchURL = `${baseApi}/responses/delete-response/${responseId}`;
  return await getRequest(fetchURL, "API/apiDeleteResponse");
}

export async function apiShadowCopyFormResponses(payload: ShadowCopyFormResponsesPayload) : 
  Promise<FormResponseExtended[] | null> {
  const fetchURL = `${baseApi}/responses/shadow-copy-form-responses`;
  return await postRequest(fetchURL, payload, "API/apiShadowCopyFormResponses");
}